import type { FieldContext } from 'vee-validate';

type InteractionEventGetter = (ctx: FieldContext) => string[];

// Validates on submit only
const passive = () => [];

const lazy: InteractionEventGetter = ({ meta, errorMessage }) => {
  return ['change'];
};

const aggressive: InteractionEventGetter = () => ['input'];

const eager: InteractionEventGetter = ({ meta, errorMessage }) => {
  if (errorMessage.value) {
    return ['input'];
  }

  return ['change'];
};

export type InteractionMode = {
  passive: any;
  lazy: InteractionEventGetter;
  aggressive: any;
  eager: InteractionEventGetter;
};

export const modes: InteractionMode = {
  passive,
  lazy,
  aggressive,
  eager,
};
